import SubcategoryPage from '@/components/template/SubcategoryPage';

const ReflexShelf = () => {
  const products = [
    {
      title: "Reflex Shelf Model 1",
      imageSrc: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&q=80",
      url: "/ogledala/reflex-shelf/model-1"
    },
    {
      title: "Reflex Shelf Model 2",
      imageSrc: "https://images.unsplash.com/photo-1617004518200-f3b8191fdc1d?auto=format&fit=crop&q=80",
      url: "/ogledala/reflex-shelf/model-2"
    },
    {
      title: "Reflex Shelf Model 3",
      imageSrc: "https://images.unsplash.com/photo-1489171078254-c3365d6e359f?auto=format&fit=crop&q=80",
      url: "/ogledala/reflex-shelf/model-3"
    },
    {
      title: "Reflex Shelf Model 4",
      imageSrc: "https://images.unsplash.com/photo-1596079890701-dd42edf0b7d4?auto=format&fit=crop&q=80",
      url: "/ogledala/reflex-shelf/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Reflex Shelf"
      description="Funkcionalna ogledala z integrirano polico za shranjevanje. Idealna rešitev za manjše prostore, kjer je pomembna vsaka površina."
      heroImage="https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default ReflexShelf;